// How a sale's status reads on screen (Oct 2026). Stored values stay as they are, so incentives,
// reports and old sales keep working:
// - "FE Conversion" on a consult's own sale = a new member's front-end sale → "FE New Sale"
// - "FE Conversion" entered in All Sales = a front-end member staying on → "FE Retention"
//   ("(previously FE Conversion)" until RENAME_NOTE_UNTIL, so people recognise it)
export const RENAME_NOTE_UNTIL = "2026-11-21";

export const feRetentionLabel = () =>
  (new Date().toISOString().slice(0, 10) < RENAME_NOTE_UNTIL ? "FE Retention (previously FE Conversion)" : "FE Retention");

// A free URU Games pass (backend routes/uru_pass.py) is stored like an app front-end sale: show what it is.
const URU_PASS = "urU 2-week pass".toLowerCase();

export function statusLabel(status, sale = {}) {
  if ((sale.programme || "").trim().toLowerCase() === URU_PASS) return "URU Pass";
  if ((status || "").trim() !== "FE Conversion") return status;
  return sale.lead_id ? "FE New Sale" : feRetentionLabel();
}
